/**
 * BugNoteEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { BugEntity } from "../BugEntity";
import { VisitEntity } from "../VisitEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { PhaseEntity } from "../PhaseEntity";
import { BugTransitionEntity } from "../BugTransitionEntity";
import { BugStateEntity } from "../BugStateEntity";
import { BugNoteAnnotationEntity } from "../BugNoteAnnotationEntity";
import { SignOffEntity } from "../SignOffEntity";
import { BugNoteEntity } from "../BugNoteEntity";
declare global {
    interface EntityTypeMap {
        BugNote: BugNoteEntity;
    }
}
export abstract class BugNoteGeneratedEntity extends BaseEntity {
    public abstract bugNoteId: string;
    public abstract templateId: string | null;
    public abstract creationDate: Date;
    public abstract date: Date;
    public abstract text: string | null;
    public abstract type: number;
    public abstract temp: boolean;
    public abstract bug: BugEntity;
    public abstract visit: VisitEntity | null;
    public abstract user: ProjectUserEntity | null;
    public abstract phase: PhaseEntity | null;
    public abstract bugTransition: BugTransitionEntity | null;
    public abstract bugState: BugStateEntity | null;
    public abstract readonly annotations: ReadonlyArray<BugNoteAnnotationEntity>;
    public abstract signOff: SignOffEntity | null;
}
